import { z } from 'zod';

type T = (key: string) => string;

export const REJECT_TARGET_STAGES = ['registration', 'sticking'] as const;

export const PREDEFINED_REASONS = [
  'blurry_images',
  'poor_lighting',
  'wrong_angle',
  'missing_images',
  'container_not_visible',
  'incomplete_sticking',
  'data_mismatch',
  'other'
] as const;

export const createRejectFormSchema = (t: T, isOtherSelected = false) =>
  z.object({
    target_stage: z.enum(REJECT_TARGET_STAGES, {
      message: t('targetStageRequired')
    }),
    predefined_reason: z.string().min(1, t('reasonRequired')),
    additional_notes: isOtherSelected
      ? z
          .string()
          .min(10, t('additionalNotesMinLength'))
          .max(500, t('additionalNotesMaxLength'))
      : z.string().max(2000).optional().or(z.literal(''))
  });

export const rejectFormSchema = createRejectFormSchema((key) => {
  const defaults: Record<string, string> = {
    targetStageRequired: 'Target stage is required.',
    reasonRequired: 'Rejection reason is required.'
  };
  return defaults[key] ?? key;
});

export type RejectFormValues = z.infer<typeof rejectFormSchema>;
